import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function AddManagerScenario(props) {
  const [EnvironmentList, setEnvironmentList] = useState([]);
  const [CharacterList, setCharacterList] = useState([]);
  const [CharacterList1, setCharacterList1] = useState([]);
  const [EnvironmentId, setEnvironmentId] = React.useState("");
  const [CharacterId, setCharacterId] = React.useState("");
  const [CharacterId1, setCharacterId1] = React.useState("");
  const [EnvironmentImgPreview, setEnvironmentImgPreview] = React.useState("");
  const [CharacterImgPreview, setCharacterImgPreview] = React.useState("");
  const [CharacterImgPreview1, setCharacterImgPreview1] = React.useState("");
  const mangerId = localStorage.getItem("ManegerId");
  const [LastScenarioId, setLastScenarioId] = useState([]);

  const [formData, setName] = useState({
    ScenarioName: "",
    Place: "",
    UserRole: "",

    CharacterName: "",
    DateOfBirth: "",
    Gender: "",
    CharacterRole: "",
    CharacterAddress: "",
    PersonalLife: "",
    CaseDescription: "",

    CharacterName1: "",
    DateOfBirth1: "",
    Gender1: "",
    CharacterRole1: "",
    CharacterAddress1: "",
    PersonalLife1: "",
    CaseDescription1: "",

    Skill1: "",
    SkillDesc1: "",
    Skill2: "",
    SkillDesc2: "",
    Skill3: "",
    SkillDesc3: "",
    Skill4: "",
    SkillDesc4: "",
    Skill5: "",
    SkillDesc5: "",
    Skill6: "",
    SkillDesc6: "",
    AboutTheCase: ""
  });

  const navigate = useHistory();

  useEffect(() => {
    LoadPatient();
    LoadCasesLimit();
    LoadEnvironments();
    LoadCharacters();
  }, []);

  const LoadPatient = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/GetLastScenarioId`).then((res) => {
      const lastPatient = res.data;

      const newPatientId = parseInt(lastPatient) + 1;
      setLastScenarioId(newPatientId.toString());
    }).catch( (err) => {
      if(err instanceof TypeError){
        setLastScenarioId(1);
      }else
        setLastScenarioId(err);
    });
  };

  const LoadCasesLimit = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCasesLimit`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    // TODO: Change error message
    axios(authOptions).then((res) => {
      var casesLimitData = res.data.data;
      const casesRemaining = parseInt(casesLimitData.cases_Remaining);
      const casesLimit = parseInt(casesLimitData.cases_Limit);
      const totalCasesLimit = parseInt(casesLimitData.total_Cases_Limit);
      const limit = totalCasesLimit > 0 ? totalCasesLimit : casesLimit;

      if(limit > 0 && casesRemaining < 1){
        Swal.fire({
          title: "Limit!",
          text: "You have reached the maximum number of cases",
          icon: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate.push("/ScenarioList");
          }
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const LoadEnvironments = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetScenarioEnvByManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setEnvironmentList(res.data.data);
    });
  };

  const LoadCharacters = () => {
    const datavalue = {
      managerId: mangerId,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetCharacterByManager`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions).then((res) => {
      setCharacterList(res.data.data);
      setCharacterList1(res.data.data);
    });
  };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  // Function called when Form Submitted
  const ScenarioSubmit = async (e) => {
    e.preventDefault();

    if (
      formData.ScenarioName === "" ||
      formData.Place === "" ||
      formData.UserRole === "" ||
      EnvironmentId === "" ||

      formData.CharacterName === "" ||
      formData.DateOfBirth === "" ||
      formData.Gender === "" ||
      formData.CharacterRole === "" ||
      formData.CharacterAddress === "" ||
      formData.PersonalLife === "" ||
      formData.CaseDescription === "" ||
      CharacterId === "" ||

      formData.CharacterName1 === "" ||
      formData.DateOfBirth1 === "" ||
      formData.Gender1 === "" ||
      formData.CharacterRole1 === "" ||
      formData.CharacterAddress1 === "" ||
      formData.PersonalLife1 === "" ||
      formData.CaseDescription1 === "" ||
      CharacterId1 === ""
      ) {
        if (formData.ScenarioName === "") {
            Swal.fire({
              title: "Error",
              text: "Scenario Name is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.Place === "") {
            Swal.fire({
              title: "Error",
              text: "Scenario Location is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.UserRole === "") {
            Swal.fire({
              title: "Error",
              text: "User's Role is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (EnvironmentId === "") {
            Swal.fire({
              title: "Error",
              text: "Please select Environment",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }

        if (formData.CharacterName === "") {
            Swal.fire({
              title: "Error",
              text: "Character Name is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.DateOfBirth === "") {
            Swal.fire({
              title: "Error",
              text: "Character's DOB is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.Gender === "") {
            Swal.fire({
              title: "Error",
              text: "Select Geder",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CharacterRole === "") {
            Swal.fire({
              title: "Error",
              text: "Character Role is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CharacterAddress === "") {
            Swal.fire({
              title: "Error",
              text: "Character Address is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.PersonalLife === "") {
            Swal.fire({
              title: "Error",
              text: "Enter Character's Personal Life",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CaseDescription === "") {
            Swal.fire({
              title: "Error",
              text: "Case Description is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (CharacterId === "") {
            Swal.fire({
              title: "Error",
              text: "Please select Character",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }

        if (formData.CharacterName1 === "") {
            Swal.fire({
              title: "Error",
              text: "Character Name is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.DateOfBirth1 === "") {
            Swal.fire({
              title: "Error",
              text: "Character's DOB is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.Gender1 === "") {
            Swal.fire({
              title: "Error",
              text: "Select Geder",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CharacterRole1 === "") {
            Swal.fire({
              title: "Error",
              text: "Character Role is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CharacterAddress1 === "") {
            Swal.fire({
              title: "Error",
              text: "Character Address is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.PersonalLife1 === "") {
            Swal.fire({
              title: "Error",
              text: "Enter Character's Personal Life",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (formData.CaseDescription1 === "") {
            Swal.fire({
              title: "Error",
              text: "Case Description is Required",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
        if (CharacterId1 === "") {
            Swal.fire({
              title: "Error",
              text: "Please select Character",
              icon: "error",
              confirmButtonText: "Ok",
            });
        }
    } else {
      const datavalue = {
        Manager_Id: mangerId,

        Scenario_Id: LastScenarioId,
        Scenario_Name: formData.ScenarioName.charAt(0).toUpperCase() + formData.ScenarioName.slice(1),
        Scenario_Location: formData.Place.charAt(0).toUpperCase() + formData.Place.slice(1),
        User_Role: formData.UserRole.charAt(0).toUpperCase() + formData.UserRole.slice(1),
        Environment_Id: EnvironmentId,

        Character_Name: formData.CharacterName.charAt(0).toUpperCase() + formData.CharacterName.slice(1),
        Character_DOB: formData.DateOfBirth,
        Character_Gender: formData.Gender,
        Character_Role: formData.CharacterRole.charAt(0).toUpperCase() + formData.CharacterRole.slice(1),
        Character_Address: formData.CharacterAddress.charAt(0).toUpperCase() + formData.CharacterAddress.slice(1),
        Personal_Life: formData.PersonalLife.charAt(0).toUpperCase() + formData.PersonalLife.slice(1),
        Case_Description: formData.CaseDescription.charAt(0).toUpperCase() + formData.CaseDescription.slice(1),
        Character_Id: CharacterId,

        Character_Name1: formData.CharacterName1.charAt(0).toUpperCase() + formData.CharacterName1.slice(1),
        Character_DOB1: formData.DateOfBirth1,
        Character_Gender1: formData.Gender1,
        Character_Role1: formData.CharacterRole1.charAt(0).toUpperCase() + formData.CharacterRole1.slice(1),
        Character_Address1: formData.CharacterAddress1.charAt(0).toUpperCase() + formData.CharacterAddress1.slice(1),
        Personal_Life1: formData.PersonalLife1.charAt(0).toUpperCase() + formData.PersonalLife1.slice(1),
        Case_Description1: formData.CaseDescription1.charAt(0).toUpperCase() + formData.CaseDescription1.slice(1),
        Character_Id1: CharacterId1,

        About_The_Case: formData.AboutTheCase.charAt(0).toUpperCase() + formData.AboutTheCase.slice(1),
        Skill1: formData.Skill1,
        SkillDesc1: formData.SkillDesc1,
        Skill2: formData.Skill2,
        SkillDesc2: formData.SkillDesc2,
        Skill3: formData.Skill3,
        SkillDesc3: formData.SkillDesc3,
        Skill4: formData.Skill4,
        SkillDesc4: formData.SkillDesc4,
        Skill5: formData.Skill5,
        SkillDesc5: formData.SkillDesc5,
        // Skill6: formData.Skill6,
        Skill6: "",
        // SkillDesc6: formData.SkillDesc6,
        SkillDesc6: "",
      };
      var authOptions = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/AddManegerScenario`,
        data: JSON.stringify(datavalue),
        headers: { "Content-Type": "application/json" },
        json: true,
      };
      axios(authOptions)
        .then((res) => {
          if(res.data.SuccessResult){
            Swal.fire({
              title: "Success",
              text: res.data.SuccessResult,
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            }).then(function () {
              navigate.push("/ScenarioList");
            });
          }else if(res.data.ExpResult){
            Swal.fire({
              title: "Error",
              text: res.data.ExpResult,
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          }else{
            Swal.fire({
              title: "Error",
              text: "Something went wrong!",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1e2b38"
            });
          }
        })
        .catch((error) => {
          //console.log("error occur", error);
        });
    }
  };

  const handleChangeEnvironment = (event) => {
    let env_id = event.target.value
    if(env_id != ""){
      setEnvironmentId(env_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetScenarioEnvImageById?EnvironmentId=` + env_id;
      setEnvironmentImgPreview(imagepath);
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      img.style.height = "auto";
    }else{
      setEnvironmentId("");
      var img = document.getElementById("envImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  };

  const handleChangeCharacter = (event) => {
    let character_id = event.target.value
    if(character_id != ""){
      setCharacterId(character_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview(imagepath);
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "visible";
      img.style.width = "100%";
      img.style.height = "auto";
    }else{
      setCharacterId("");
      var img = document.getElementById("characterImgPreview");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  };

  const handleChangeCharacter1 = (event) => {
    let character_id = event.target.value
    if(character_id != ""){
      setCharacterId1(character_id);
      var imagepath = `${process.env.REACT_APP_API_URL}/GetCharacterImageById?CharacterId=` + character_id;
      setCharacterImgPreview1(imagepath);
      var img = document.getElementById("characterImgPreview1");
      img.style.visibility = "visible";
      img.style.width = "100%";
      img.style.height = "auto";
    }else{
      setCharacterId1("");
      var img = document.getElementById("characterImgPreview1");
      img.style.visibility = "hidden";
      img.style.width = "0px";
      img.style.height = "0px";
    }
  };

  const BackFunc = () => {
    navigate.push("/ScenarioList");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">Add Scenario</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block"
                  style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2 col-sm-2"></div>
            <div className="col-md-8 col-sm-8">
              <div className="card card-box">
                <div className="card-head">
                  <header>Add Scenario</header>
                </div>
                <div className="card-body " id="bar-parent1">
                  <form
                    className="register-form"
                    id="login-form"
                    onSubmit={ScenarioSubmit}
                  >
                    <div className="form-group row">
                      <label
                        className="col-sm-3 control-label"
                      >
                        Case ID{" "}
                      </label>
                      <div className="col-sm-9 pt-2">
                        <p>{LastScenarioId}</p>
                      </div>
                    </div>

                    {/* Scenario Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="ScenarioName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.ScenarioName}
                          onChange={handleChange}
                          name="ScenarioName"
                          className="form-control"
                          id="ScenarioName"
                          placeholder="Enter the name of your scenario"
                        />
                      </div>
                    </div>

                    {/* Place of Occurrence / Scenario location */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Place"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Scenario location 
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.Place}
                          onChange={handleChange}
                          name="Place"
                          className="form-control"
                          id="Place"
                          placeholder="Enter the location where the scenario is being taking place "
                        />
                      </div>
                    </div>

                    {/* User Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="UserRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        User's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.UserRole}
                          onChange={handleChange}
                          name="UserRole"
                          className="form-control"
                          id="UserRole"
                          placeholder="Enter the role of the user/learner "
                        />
                      </div>
                    </div>

                    {/* Environment  Image*/}
                    <div className="form-group row required">
                      <label
                        htmlFor="environment"
                        className="col-sm-3 control-label"
                      >
                        Environment
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="environment"
                          className="form-control select2"
                          onChange={handleChangeEnvironment}
                        >
                          <option value="">--Select--</option>
                          {EnvironmentList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.environment_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-sm-5">
                      <div className="col-sm-12 d-flex justify-content-center">
                      <a href={EnvironmentImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                            id="envImgPreview"
                            className="previewImg"
                                src={EnvironmentImgPreview}
                                style={{
                                    objectFit: "contain",
                                    visibility: "hidden"
                                }}
                            />
                        </a>
                      </div>
                      </div>
                    </div>



                    {/* Case One (1) Starts */}

                    <div style={{margin: "50px 0 20px 0"}}>
                        <h5 style={{letterSpacing: "1px", fontSize: "14px", fontWeight: "700", margin: "0", padding: "0"}}>Add Case 1</h5>
                        <hr style={{height: "2px", color: "#000"}}/>
                    </div>
                    

                    {/* Character Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterName"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterName}
                          onChange={handleChange}
                          name="CharacterName"
                          className="form-control"
                          id="CharacterName"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="DateOfBirth"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth 
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={formData.DateOfBirth}
                          onChange={handleChange}
                          name="DateOfBirth"
                          className="form-control"
                          id="DateOfBirth"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Gender"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Gender"
                          className="form-control  select2"
                          name="Gender"
                          value={formData.Gender}
                          onChange={handleChange}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterRole"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterRole}
                          onChange={handleChange}
                          name="CharacterRole"
                          className="form-control"
                          id="CharacterRole"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterAddress"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address 
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterAddress}
                          onChange={handleChange}
                          name="CharacterAddress"
                          className="form-control"
                          id="CharacterAddress"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PersonalLife"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={formData.PersonalLife}
                          onChange={handleChange}
                          name="PersonalLife"
                          className="form-control"
                          id="PersonalLife"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CaseDescription"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                        id="CaseDescription"
                          className="form-control"
                          name="CaseDescription"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.CaseDescription}
                          onChange={handleChange}
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation. "
                        />
                      </div>
                    </div>

                    {/* Character Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="character"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character"
                          className="form-control select2"
                          onChange={handleChangeCharacter}
                        >
                          <option value="">--Select--</option>
                          {CharacterList.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                      <div className="col-sm-12 d-flex justify-content-center">
                      <a href={CharacterImgPreview} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                            id="characterImgPreview"
                            className="previewImg"
                                src={CharacterImgPreview}
                                style={{
                                    objectFit: "contain",
                                    visibility: "hidden"
                                }}
                            />
                        </a>
                      </div>
                      </div>
                    </div>


                    {/* Case Two (2) Starts */}

                    <div style={{margin: "50px 0 20px 0"}}>
                        <h5 style={{letterSpacing: "1px", fontSize: "14px", fontWeight: "700", margin: "0", padding: "0"}}>Add Case 2</h5>
                        <hr style={{height: "2px", color: "#000"}}/>
                    </div>

                    {/* Character 1 Name */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterName1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character Name
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterName1}
                          onChange={handleChange}
                          name="CharacterName1"
                          className="form-control"
                          id="CharacterName1"
                          placeholder="Enter the name of your virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Date of Birth */}
                    <div className="form-group row required">
                      <label
                        htmlFor="DateOfBirth1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Date of Birth 
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          value={formData.DateOfBirth1}
                          onChange={handleChange}
                          name="DateOfBirth1"
                          className="form-control"
                          id="DateOfBirth1"
                          max={new Date()?.toISOString()?.slice(0, 10)}
                          placeholder="Enter DOB"
                        />
                      </div>
                    </div>

                    {/* Gender */}
                    <div className="form-group row required">
                      <label
                        htmlFor="Gender1"
                        className="col-sm-3 control-label"
                      >
                        Gender
                      </label>
                      <div className="col-sm-9">
                        <select
                          id="Gender1"
                          className="form-control  select2"
                          name="Gender1"
                          value={formData.Gender1}
                          onChange={handleChange}
                        >
                          <option value="">Select the gender of the virtual character </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="NonBinary">Non Binary</option>
                        </select>
                      </div>
                    </div>

                    {/* Character Role */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterRole1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character's Role
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterRole1}
                          onChange={handleChange}
                          name="CharacterRole1"
                          className="form-control"
                          id="CharacterRole1"
                          placeholder="Enter the role of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Character Address */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CharacterAddress1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Character’s Address 
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          value={formData.CharacterAddress1}
                          onChange={handleChange}
                          name="CharacterAddress1"
                          className="form-control"
                          id="CharacterAddress1"
                          placeholder="Enter the residential address of the virtual character "
                        />
                      </div>
                    </div>

                    {/* Personal Life */}
                    <div className="form-group row required">
                      <label
                        htmlFor="PersonalLife1"
                        className="col-sm-3 control-label"
                      >
                        {" "}
                        Virtual Character's Personal Life
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          value={formData.PersonalLife1}
                          onChange={handleChange}
                          name="PersonalLife1"
                          className="form-control"
                          id="PersonalLife1"
                          style={{ width: "100%", height: "100px" }}
                          placeholder="Enter details about the virtual character’s personal life, e.g., married, children, occupation, family members etc "
                        />
                      </div>
                    </div>

                    {/* Case Description */}
                    <div className="form-group row required">
                      <label
                        htmlFor="CaseDescription1"
                        className="col-sm-3 control-label"
                      >
                        Case Description
                      </label>
                      <div className="col-sm-9">
                        <textarea
                        id="CaseDescription1"
                          className="form-control"
                          name="CaseDescription1"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.CaseDescription1}
                          onChange={handleChange}
                          placeholder="Enter details about the case, e.g., what is the issue, what is the problem, what is the subject of conversation. "
                        />
                      </div>
                    </div>

                    {/* Character Image */}
                    <div className="form-group row required">
                      <label
                        htmlFor="character1"
                        className="col-sm-3 control-label"
                      >
                        Character
                      </label>
                      <div className="col-sm-4">
                        <select
                          id="character1"
                          className="form-control select2"
                          onChange={handleChangeCharacter1}
                        >
                          <option value="">--Select--</option>
                          {CharacterList1.map((result, i) => {
                            return (
                              <option value={result.id} key={result.id}>
                                {result.character_Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-sm-5">
                      <div className="col-sm-12 d-flex justify-content-center">
                      <a href={CharacterImgPreview1} target="_blank" rel="noopener" className="prevImgContainer">
                            <img
                            id="characterImgPreview1"
                            className="previewImg"
                                src={CharacterImgPreview1}
                                style={{
                                    objectFit: "contain",
                                    visibility: "hidden"
                                }}
                            />
                        </a>
                      </div>
                      </div>
                    </div>


                    <hr style={{height: "2px", color: "#000", marginTop: "30px", marginBottom: "10px"}}/>
                    <h4 style={{ textAlign: "center", marginTop: "0", marginBottom: "20px", fontWeight: "800" }}>Additional Details</h4>

                    {/* Assessment Blueprint */}
                    <div className="form-group row required">
                      <label
                        htmlFor="assessmentBlueprint"
                        className="col-sm-3 control-label"
                      >
                        Assessment Blueprint
                      </label>
                      <div className="col-sm-9">
                        <div className="row">
                          <div className="col-sm-4">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill1" value={formData.Skill1} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc1" className="form-control" value={formData.SkillDesc1} onChange={handleChange}/>
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill2" value={formData.Skill2} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc2" className="form-control" value={formData.SkillDesc2} onChange={handleChange}/>
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill3" value={formData.Skill3} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc3" className="form-control" value={formData.SkillDesc3} onChange={handleChange}/>
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill4" value={formData.Skill4} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc4" className="form-control" value={formData.SkillDesc4} onChange={handleChange}/>
                          </div>

                          <div className="col-sm-4 mt-3">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill5" value={formData.Skill5} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8 mt-3">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc5" className="form-control" value={formData.SkillDesc5} onChange={handleChange}/>
                          </div>

                          <div className="col-sm-4 mt-3 d-none">
                            <input type="text" placeholder="Skill name" className="form-control" name="Skill6" value={formData.Skill6} onChange={handleChange}/>
                          </div>
                          <div className="col-sm-8 mt-3 d-none">
                            <input type="text" placeholder="Enter the description of the competency being assessed." name="SkillDesc6" className="form-control" value={formData.SkillDesc6} onChange={handleChange}/>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* About The Case */}
                    <div className="form-group row required">
                      <label
                        htmlFor="AboutTheCase"
                        className="col-sm-3 control-label"
                      >
                        About The Case
                      </label>
                      <div className="col-sm-9">
                        <textarea
                        id="AboutTheCase"
                          className="form-control"
                          name="AboutTheCase"
                          style={{ width: "100%", height: "100px" }}
                          value={formData.AboutTheCase}
                          onChange={handleChange}
                          placeholder="About the case ... "
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 text-end">
                        <button
                          type="submit"
                          className="btn d-inline-block"
                          style={{backgroundColor: "#1e2b38", color: "#FFF", border: "1px solid #1e2b38"}}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddManagerScenario;
